import React from "react";

const RetailbusinessIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7594_38884"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7594_38884)">
        <path
          className="prompt-icon"
          d="M11.4103 6.42292H12.5897V5.24359H11.4103V6.42292ZM11.4103 9.08959H12.5897V7.91025H11.4103V9.08959ZM11.4103 11.7563H12.5897V10.5769H11.4103V11.7563ZM11 14.1666V13.1666H14V3.83325H7.79483V5.02942L6.79483 4.30642V2.83325H15V14.1666H11ZM1 14.1666V7.99992L5.33333 4.91025L9.66667 7.99992V14.1666H6.08983V10.9999H4.57683V14.1666H1ZM2 13.1666H3.577V9.99992H7.08967V13.1666H8.66667V8.49992L5.33333 6.14609L2 8.49992V13.1666Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default RetailbusinessIcon;
